// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



//////////////////
// WEBPACK FOOTER
// ../core-js/library/modules/es7.map.of.js
// module id = 2140
// module chunks = 25